import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import "./index.css";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { NotificationProvider } from "./context/NotificationContext";
import { ErrorBoundary } from "./ErrorBoundary";

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={<div className="text-red-500">Oops! Something went wrong.</div>}
    >
      <AgoraRTCProvider client={client}>
        <AuthProvider>
          <NotificationProvider />
          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                padding: "10px",
                borderRadius: "5px",
              },
              success: {
                style: {
                  borderLeft: "4px solid #22c55d", // green
                },
              },
              error: {
                style: {
                  borderLeft: "4px solid #ef4444", // red
                },
              },
              loading: {
                style: {
                  borderLeft: "4px solid #3b82f6", // blue
                },
              },
            }}
          />

          <RouterProvider router={router} />
        </AuthProvider>
      </AgoraRTCProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
